import React, { Component } from "react";
import FaqsListItem from "./faqs-list-item";

class FAQsList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const faqList = this.props.FAQs; //[{ question: "Første sprøgsmål", answer: "lorem svar på første spgmmaslkfj"}, { question: "Andet sprøgsmål", answer: "lorem svar på andet spgmmaslkfj"}, { question: "Tredje sprøgsmål", answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad cumque earum, et excepturi facilis in, ipsam itaque modi quae qui similique, voluptatum? Aliquam animi assumenda dignissimos dolor dolorum ipsam saepe."}];

        return (
            <div className="faq-section">
                <div className="content-row">
                    <div className="article-content">
                        {this.props.FAQListTitle && (
                            <div
                                className="featured-article__trumpet"
                                dangerouslySetInnerHTML={{ __html: this.props.FAQListTitle }}
                            ></div>
                        )}
                        {faqList.map((item, index) => {
                            return <FaqsListItem key={index} title={item.Question} content={item.Answer} />;
                        })}
                    </div>
                </div>
            </div>
        );
    }
}
export default FAQsList;
